const custom_profile_fields = {
    entity_not_exists_with_names: 'موجودیت‌هایی با نام‌های داده‌شده یافت نشد: {{names}}',
    invalid_min_max_input: 'ورودی min و max نامعتبر است.',
    invalid_default_value: 'مقدار پیش‌فرض نامعتبر است.',
    invalid_options: 'گزینه‌های فیلد نامعتبر است.',
    invalid_regex_format: 'قالب regex نامعتبر است.',
    invalid_address_components: 'اجزای آدرس نامعتبر است.',
    invalid_fullname_components: 'اجزای نام کامل نامعتبر است.',
    invalid_sub_component_type: 'نوع زیرکامپوننت نامعتبر است.',
    name_exists: 'فیلدی با این نام از قبل وجود دارد.',
    conflicted_sie_order: 'مقدار ترتیب فیلد متعارض برای تجربه ورود.',
    invalid_name: 'نام فیلد نامعتبر است؛ فقط حروف یا اعداد مجاز است و به حروف بزرگ/کوچک حساس است.',
    name_conflict_sign_in_identifier: 'نام فیلد نامعتبر است. کلید(های) شناسه ورود رزروشده: {{name}}.',
    name_conflict_built_in_prop: 'نام فیلد نامعتبر است. نام(های) ویژگی پروفایل کاربر داخلی رزروشده: {{name}}.',
    name_conflict_custom_data: 'نام فیلد نامعتبر است. کلید(های) داده سفارشی رزروشده: {{name}}.',
    name_required: 'نام فیلد الزامی است.',
};
export default Object.freeze(custom_profile_fields);
